module.exports = __webpack_public_path__ + "img/AddModeratorOutlined.8d463a6d.svg";